import React from 'react';

import ProtectedRecordingWhite from 'assets/images/svgs/Recording/ico_protected_recording.svg';
import ProtectedRecordingBlack from 'assets/images/svgs/Recording/ico_protected_recording_black.svg';

type Props = { highlighted: boolean; size: number };

function ProtectedRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <ProtectedRecordingBlack width={size} height={size} />
    ) : (
        <ProtectedRecordingWhite width={size} height={size} />
    );
}

export default ProtectedRecording;
